import { useNavigate } from "react-router-dom";
import SectionHeader from "@/components/base/SectionHeader";

const experiencePoints = [
  {
    icon: "ri-government-line",
    title: "Federal Enterprise IT",
    description: "Through subcontract and teaming relationships with higher-tier partners, Mitaja supports federal enterprise IT operations with infrastructure, network engineering, database administration, and specialist technical resources.",
  },
  {
    icon: "ri-building-line",
    title: "Enterprise Business Applications",
    description: "Provides Power Platform, SharePoint, application, and platform support for enterprise business applications and collaboration environments.",
  },
];

export default function GovernmentExperienceSection() {
  const navigate = useNavigate();

  return (
    <section className="section-padding bg-background-100">
      <div className="container-page">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <SectionHeader
              title="Government Experience"
              subtitle="Federal Programs"
              description="Mitaja supports federal enterprise IT environments through established subcontract relationships with prime contractors and higher-tier technology partners."
              centered={false}
            />
            <div className="space-y-6">
              {experiencePoints.map((point) => (
                <div key={point.title} className="flex gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className={`${point.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-1">
                      {point.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {point.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => { navigate("/experience/usa-government"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                className="btn-primary"
              >
                Explore Government Services
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => { navigate("/experience"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                className="btn-secondary"
              >
                View Past Performance
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden bg-primary-800">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20government%20enterprise%20IT%20operations%20center%2C%20network%20monitoring%20displays%20and%20server%20infrastructure%2C%20dark%20professional%20environment%20with%20subtle%20blue%20accent%20lighting%2C%20no%20people%2C%20cinematic%20photography%2C%20clean%20minimal%20composition&width=800&height=600&seq=gov-exp-1&orientation=landscape"
                alt="Enterprise IT operations"
                className="w-full h-80 md:h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 to-transparent"></div>
            </div>
            <div className="absolute -bottom-4 -left-4 md:-left-6 bg-white rounded-lg p-4 md:p-5 border border-background-200/80 max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 rounded-full bg-accent-50 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">Subcontract Performance</span>
              </div>
              <p className="text-sm font-semibold text-foreground-800">
                Federal enterprise IT support through established prime-contractor partnerships
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}